import { learningClient } from '../api'
import { IOffsetPaginationResponse } from '@sphere/shared/domain'
import {
  Attempt,
  CanStartAttempt,
  AttemptStatistics,
  GradeAttemptRequestDto,
  ListAttemptsRequestDto,
  StartAttemptRequestDto,
  SubmitAttemptRequestDto,
  UpdateAttemptRequestDto,
  UpdateGradingRequestDto,
} from '@sphere/learning/domain'

export async function fetchAttempts(
  params: ListAttemptsRequestDto
): Promise<IOffsetPaginationResponse<Attempt>> {
  const response = await learningClient.attempts.list(params)
  return response.data
}

export async function fetchAttemptById(id: string): Promise<Attempt> {
  const response = await learningClient.attempts.getById(id)
  return response.data
}

export async function startAttempt(
  activityId: string,
  data: StartAttemptRequestDto
): Promise<Attempt> {
  const response = await learningClient.attempts.start(activityId, data)
  return response.data
}

export async function canStartAttempt(
  activityId: string
): Promise<CanStartAttempt> {
  const response = await learningClient.attempts.canStart(activityId)
  return response.data
}

export async function submitAttempt(
  attemptId: string,
  data?: SubmitAttemptRequestDto
): Promise<Attempt> {
  const response = await learningClient.attempts.submit(attemptId, data)
  return response.data
}

export async function gradeAttempt(
  attemptId: string,
  data: GradeAttemptRequestDto
): Promise<Attempt> {
  const response = await learningClient.attempts.grade(attemptId, data)
  return response.data
}

export async function updateGrading(
  attemptId: string,
  data: UpdateGradingRequestDto
): Promise<Attempt> {
  const response = await learningClient.attempts.updateGrading(attemptId, data)
  return response.data
}

export async function updateAttempt(
  attemptId: string,
  data: UpdateAttemptRequestDto
): Promise<Attempt> {
  const response = await learningClient.attempts.update(attemptId, data)
  return response.data
}

export async function deleteAttempt(id: string): Promise<void> {
  await learningClient.attempts.delete(id)
}

export async function fetchMyStatistics(): Promise<AttemptStatistics> {
  const response = await learningClient.attempts.getMyStatistics()
  return response.data
}

export async function fetchAttemptResult(id: string): Promise<Attempt> {
  const response = await learningClient.attempts.getResult(id)
  return response.data
}
